var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagSeychelles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0107C24.8366 32.0107 32 24.8473 32 16.0107C32 7.17419 24.8366 0.0107422 16 0.0107422C7.16344 0.0107422 0 7.17419 0 16.0107C0 24.8473 7.16344 32.0107 16 32.0107Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8001 4.2068C23.9539 1.60105 20.1625 0.0107422 15.9995 0.0107422C15.318 0.0107422 14.6465 0.0536797 13.9874 0.136367L6.26042 9.05424L0.505859 20.0189C0.877609 21.4602 1.44598 22.8224 2.1793 24.0762L15.9995 16.0107L26.8001 4.2068Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.321 24.8755L6.93555 29.1955C9.51236 30.9706 12.6347 32.0106 16.0004 32.0106C21.5579 32.0106 26.4529 29.1767 29.321 24.8755Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8024 4.20898L2.18848 24.0918C2.83229 25.1898 3.6031 26.2042 4.48104 27.1148L31.9996 16.0108C31.9996 11.3384 29.9964 7.13411 26.8024 4.20898Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.0108C0 17.395 0.175875 18.7381 0.506312 20.019L13.9878 0.136475C6.10112 1.1261 0 7.85585 0 16.0108Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16430"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagSeychelles);
export default __webpack_public_path__ + "static/media/flag_seychelles.f141010d8f15d9a73b5482f5571ecea7.svg";
export { ForwardRef as ReactComponent };